export default __webpack_public_path__ + "static/media/dr_karl.429d4e3c.jpg";